import * as React from "react";
import {
  FilledInput,
  TextField,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { useWatch } from "react-hook-form";
import { useInput, InputHelperText } from "react-admin";
import { CurrencyEnum } from "src/common/enum/CurrencyEnum";

export const PriceInput = (props) => {
  const {
    field,
    fieldState: { isTouched, invalid, error },
    formState: { isSubmitted },
    isRequired,
  } = useInput(props);

  const currency = useWatch({ name: props?.currencyField, defaultValue: "EUR" });

  return (
    <>
      <FormControl
        fullWidth
        sx={{ input: { p: "9px" } }}
        error={(isTouched || isSubmitted) && invalid}
        required={isRequired}
      >
        <InputLabel htmlFor="outlined-adornment-amount">
          {props?.label}
        </InputLabel>
        <OutlinedInput
          id="outlined-adornment-amount"
          type="number"
          {...field}
          startAdornment={
            <InputAdornment position="start">
              {CurrencyEnum.find((c) => c.id === currency)?.symbol}
            </InputAdornment>
          }
          label={props?.label}
        />
        <FormHelperText error={props?.helperText !== false || ((isTouched || isSubmitted) && invalid)}>
          <InputHelperText
            touched={isTouched || isSubmitted}
            error={error?.message}
            helperText={props?.helperText}
          />
        </FormHelperText>
      </FormControl>
    </>
  );
};
